import { Observable } from 'rxjs';
import { AjaxConfig, AjaxResponse } from 'rxjs/ajax';

import { HttpHandler } from 'app/http/http-handler';
import { Interceptor } from 'app/http/interceptor';
import { AppStore } from 'app/store';
import { selectProdDataStatus } from 'features/cris/cris.slice';

export class ShowProdDataHeaderInterceptor implements Interceptor {
    public intercept<T>(store: AppStore, req: AjaxConfig, next: HttpHandler<T>): Observable<AjaxResponse<T>> {
        req.headers = {
            'X-Prod-Data-Request': selectProdDataStatus(store.getState()) ? 1 : 0,
            ...req.headers,
        };

        return next.handle(req);
    }
}
